<template>
  <MerchantPaymentList
    title="Success Transactions"
    default-status="paid"
    :status-options="statusOptions"
  />
</template>
<script>
import MerchantPaymentList from "./MerchantPaymentList.vue";

export default {
  name: "SuccessTransaction",
  components: { MerchantPaymentList },
  data() {
    return {
      // Values sent as ?status=... to GET merchant/payments.
      // The API returns status "paid" (Completed) and "pending" (Pending),
      // so both screens can filter by either.
      statusOptions: [
        { value: "", text: "All Status" },
        { value: "paid", text: "Completed" },
        { value: "pending", text: "Pending" },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
</style>
